import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// DEBUG: Enhanced patch to find undefined module with better logging
// const originalMap = Array.prototype.map;
// Array.prototype.map = function (this: any[], callback: any, thisArg?: any) {
//   for (let i = 0; i < this.length; i++) {
//     if (this[i] === undefined || this[i] === null) {
//       console.error('🔴 FOUND UNDEFINED MODULE at index', i);
//       console.error('Previous item (index ' + (i - 1) + '):', this[i - 1]);
//       console.error('Undefined item (index ' + i + '):', this[i]);
//       console.error('Next item (index ' + (i + 1) + '):', this[i + 1]);
//       console.error('Full array with all items:');
//       this.forEach((item, idx) => {
//         console.log(
//           `  [${idx}]: ${item?.name || item?.constructor?.name || typeof item}`,
//           item
//         );
//       });
//       console.trace('Stack trace:');
//       debugger; // Pause execution to inspect
//     }
//   }
//   return originalMap.call(this, callback, thisArg);
// };

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import Gleap from 'gleap';
import { register } from 'swiper/element/bundle';

register();

if (environment.production) {
  enableProdMode();
}

// Please make sure to call this method only once!
Gleap.initialize(environment.gleap.projectKey);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
